const getMenuItems = state => state?.platform?.splashScreen?.menu;
const getSplashScreenStatus = state => state?.platform?.splashScreen?.status;

export { getMenuItems, getSplashScreenStatus };
